<template>
    <v-container>
        <v-row style="height: 100vh" align="center" class="text-center">
            <v-col cols="12" sm="12">
                <v-progress-circular
                        size="50"
                        color="primary"
                        indeterminate
                ></v-progress-circular>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        mounted() {
            this.verifyDetails();
        },
        data() {
            return {
                userType: null,
                userId: null
            };
        },
        methods: {
            verifyDetails() {
                this.userType = this.$route.query.userType;
                this.userId = this.$route.query.userId;
                let url = this.userType === 'DOCTOR' ? 'doctors' : 'patients';
                this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$route.query.accessToken;
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/` + url + `/${this.userId}`)
                    .then((response) => {

                        let loginObject = {
                            accessToken: this.$route.query.accessToken,
                            userId: this.userId,
                            userType: this.userType,
                            userInfo: response.data.data,
                            mobile: response.data.data.mobile,
                            timezone:response.data.data.timezone,
                        }
                        
                        this.$store.dispatch('userLogin', loginObject);
                        this.$emit('logged-in', true);                        
                        this.$store.dispatch('storeUserInfo', loginObject.userInfo)
                        //this.$router.push({name: 'myAppointments'})
                        this.redirectUser()
                        window.subscribeToken()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            redirectUser(){
                var current_url = new URL(window.location.href)
                const urlParams = new URLSearchParams(current_url.search); 
                var redirectTo = urlParams.get('redirect');                
                if(redirectTo != null && redirectTo.length >0)
                    window.location.replace(redirectTo)
                else
                    this.$router.replace({name: 'myAppointments'})

                
            },
        },
    }
</script>

<style scoped>

</style>